function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import styles from './Pages.pcss';
var _React_PureComponent;
class Page extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { children, active, onClick } = this.props;
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            onClick: onClick,
            className: cn('page', {
                'page--active': active
            }),
            children: children
        });
    }
}
_define_property(Page, "propTypes", {
    children: PropTypes.node,
    active: PropTypes.bool,
    onClick: PropTypes.func
});
export default withStyles(styles)(Page);
